import { createFileRoute } from '@tanstack/react-router'
import { requireAnyPermission } from '../../../app/guards'
import { LoyaltyProgramPage } from '../../../features/loyalty/program-page'

/** Read with loyalty.read, changed with loyalty.manage. */
export const Route = createFileRoute('/_app/loyalty/program')({
  staticData: { crumb: 'loyaltyProgram' },
  beforeLoad: ({ context }) => requireAnyPermission(context.session, 'loyalty.read', 'loyalty.manage'),
  component: LoyaltyProgramPage,
})
